export default __webpack_public_path__ + "static/media/coiffeur-search.a456e06f.svg";